import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

async function boot() {
  if (window.location.pathname === '/ops') {
    const { pcaReady } = await import('./lib/msal');
    await pcaReady;
  }

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

void boot();

